/**
 * Red Tiki Quicklook Modal Plugin for Shopify
 * - adds the ability to specify triggers that will load a product into a modal
 * - data is loaded async via the shopify ajax api
 * - relies on jsrender and bootstrap (3+)
 **/

function QuicklookModal(opts)
{
  
  var options = $.extend({
    
    modalSelector: '',
    productTemplateSelector: '',
    modalBodySelector: '',
    loadingDiv: '<div class="loading-quicklook-modal">Loading, please wait...</div>',
    triggerSelector: '.quick-look-btn',
    
    modalReady: function(quicklookModal)
    {
      
    }
  },opts);
  
  return {
    
    modal: false,
    
    init: function()
    {
      var self = this;
      //setup the modal but don't show it...
      this.modal = $(options.modalSelector).modal({
        show: false
      });
      
      this.modalProductTemplate = $.templates(options.productTemplateSelector);
      
      console.log(this.modalProductTemplate);
      
      //add the event / trigger setup
      $( document ).on( "click", options.triggerSelector, function(e) {
        var productId = $(this).data('productid');
        if (productId)
        {
         	self.showModal(productId);
        }
        e.preventDefault();
        return false;
      });
      
    },
    
    showModal: function(productId)
    {
      	
      var self = this;
      	
      	//ensure that the loading message is present...
      $(options.modalBodySelector).html(options.loadingDiv);
      	
      this.modal.modal('show');
      
      $.ajax({
        url: '/products/'+productId+'.js',
        dataType: 'json'
      }).done(function(product){
    	
        console.log(product.title);
        
        //render the product modal and pass it to the modal body
        var html = self.modalProductTemplate.render(product);
        
        $(options.modalBodySelector).html(html);
        
        options.modalReady(self);
        
      });
      	
    },
    
    hideModal: function()
    {
    	this.modal.modal('hide');
    }
    
  }
  
}